(() => {
  const enhanceQuantity = (scope = document) => {
    scope.querySelectorAll('.dt-product-template').forEach((marker) => {
      const productInfo = marker.closest('.product__info-container');
      const quantityBlock = productInfo?.querySelector('.product-form__quantity');
      const input = quantityBlock?.querySelector('input[name="quantity"]');

      if (!quantityBlock || !input || quantityBlock.dataset.dtQuantityEnhanced === 'true') return;

      const minimum = Math.max(1, Number.parseInt(input.min, 10) || 1);
      const inventoryMaximum = Number.parseInt(input.max, 10);
      const current = Math.max(minimum, Number.parseInt(input.value, 10) || minimum);
      const maximum = Number.isFinite(inventoryMaximum)
        ? Math.max(minimum, Math.min(inventoryMaximum, 5))
        : Math.max(5, current);
      const wrapper = document.createElement('span');
      const select = document.createElement('select');

      wrapper.className = 'dt-quantity-select-wrap';
      select.className = 'dt-quantity-select';
      select.setAttribute('aria-label', '数量');

      for (let quantity = minimum; quantity <= maximum; quantity += 1) {
        const option = document.createElement('option');
        option.value = String(quantity);
        option.textContent = String(quantity);
        option.selected = quantity === Math.min(current, maximum);
        select.append(option);
      }

      select.addEventListener('change', () => {
        input.value = select.value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      input.addEventListener('change', () => {
        if ([...select.options].some((option) => option.value === input.value)) {
          select.value = input.value;
        }
      });

      wrapper.append(select);
      quantityBlock.append(wrapper);
      quantityBlock.dataset.dtQuantityEnhanced = 'true';
      quantityBlock.classList.add('is-dt-quantity-select');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceQuantity());
  } else {
    enhanceQuantity();
  }

  document.addEventListener('shopify:section:load', (event) => enhanceQuantity(event.target));
})();
